// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d415665b","453":"483327f8"}[chunkId] + ".chunk.js";
};